module.exports = __webpack_public_path__ + "static/img/shopinfo_icon_ig.png";